import React from "react";
import FloatingPremiumButton from "../components/FloatingPremiumButton";
import SubscriptionExpiryPopup from "../components/SubscriptionExpiryPopup";
import DownloadLoadingModal from "../components/DownloadLoadingModal";

export default ({ children }) => {
  return (
    <div>
      {children}
      <FloatingPremiumButton />
      <SubscriptionExpiryPopup />
      <DownloadLoadingModal />
    </div>
  );
};
